import React from "react";
import { Link } from "react-router-dom";
import { featured, projects } from "../../v3/data";
import ProjectCard, { LiveBadge } from "./ProjectCard";

// home shows only the flagship picks (two full rows); the rest live on /projects
const caseStudyProjects = projects.filter((p) => p.homeFeatured);

const Work = () => (
  <section id="work" className="section rv">
    <div className="pagewrap">
      <div className="shead">
        <div>
          <div className="snum">[ 05 / SELECTED WORK ]</div>
          <h2 className="h2">Projects I'm proud of.</h2>
        </div>
        <span className="mono hide-mobile" style={{ fontSize: 12, color: "var(--muted)" }}>
          100+ SHIPPED · {String(caseStudyProjects.length + 1).padStart(2, "0")} FEATURED
        </span>
      </div>

      <div className="card feat-grid mb24" style={{ padding: 0 }}>
        <div style={{ padding: 44 }}>
          <div className="fx gap8 wrap mb20">
            <span className="tag" style={{ background: "var(--accent)", color: "#fff", borderColor: "var(--accent)" }}>
              P.01 — FEATURED
            </span>
            <span className="tag">EU-grant SaaS</span>
            <LiveBadge />
          </div>
          <h3 className="disp" style={{ fontSize: 30, fontWeight: 700, margin: "0 0 12px", letterSpacing: "-.02em" }}>
            {featured.title}
          </h3>
          <p style={{ fontSize: 15.5, lineHeight: 1.7, color: "var(--muted)", margin: "0 0 22px" }}>{featured.desc}</p>
          <div className="fx wrap gap8 mb24">
            {featured.tech.map((t) => (
              <span key={t} className="tag">
                {t}
              </span>
            ))}
          </div>
          <Link to={featured.link} className="mono fw6 fs13">
            case_study →
          </Link>
        </div>
        <div
          className="posrel"
          style={{
            minHeight: 320,
            height: "100%",
            background: "var(--soft)",
            borderLeft: "1px solid var(--line)",
            borderRadius: "0 var(--radius) var(--radius) 0",
            overflow: "hidden",
          }}
        >
          <img
            src="/assets/work/structura/landing.png"
            alt="Structura — public landing page"
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", objectPosition: "left top" }}
          />
        </div>
      </div>

      <div className="proj-grid">
        {caseStudyProjects.map((p) => (
          <ProjectCard p={p} key={p.num} />
        ))}
      </div>

      <div className="tc" style={{ marginTop: 44 }}>
        <Link to="/projects" className="btn btn-ghost">
          View all projects<span className="arr">→</span>
        </Link>
      </div>
    </div>
  </section>
);

export default Work;
